import { useFormContext } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { without } from 'lodash-es'
import { useMemo } from 'react'

import { OTHER_KINDS, ROUND_ROBIN_MOST_POPULAR_KINDS } from 'components/event_type_edit'
import { useETEditorFormikPoolingType } from 'services/event_types'

const POSSIBLE_KINDS = [
  'inbound_call',
  'outbound_call',
  'physical',
  'ask_invitee',
  'custom',
  'zoom_conference',
  'google_conference',
  'microsoft_teams_conference',
  'webex_conference',
  'gotomeeting_conference'
]

const createLocationObjects = (locations) => locations.map((location) => ({ type: 'location', value: location }))

export const useGetPropsForInline = (kind, eventType) => {
  const { values: { userPools } } = useFormContext()
  const { isRoundRobin, isCollectiveRoundRobin } = useETEditorFormikPoolingType()
  const { isGroup } = eventType

  return useMemo(() => {
    let possibleKinds
    let disabledTooltipText

    if (isGroup) {
      possibleKinds = without(POSSIBLE_KINDS, 'ask_invitee', 'outbound_call')
      disabledTooltipText = I18n.t('publisher.event_types.location.group_disabled_call_tooltip')
    }
    if (isRoundRobin || (isCollectiveRoundRobin && !userPools.some((pool) => pool.pooling_type === 'collective'))) {
      possibleKinds = without(POSSIBLE_KINDS, 'ask_invitee', 'outbound_call')
      disabledTooltipText = I18n.t('publisher.event_types.location.round_robin_disabled_call_tooltip')
    }

    const props = {
      kind,
      possibleKinds
    }

    switch (kind) {
      case 'inbound_call':
        return {
          ...props,
          tooltipText: disabledTooltipText
        }
      case 'physical':
        return {
          ...props,
          canHideLocation: false
        }
      case 'custom':
        return {
          ...props,
          canHideLocation: !isRoundRobin
        }
      case 'zoom_conference':
      case 'gotomeeting_conference':
      case 'google_conference':
      case 'microsoft_teams_conference':
      case 'webex_conference':
        return {
          ...props
        }
      default:
        return {}
    }
  }, [isGroup, isRoundRobin, isCollectiveRoundRobin, userPools, kind])
}

export const roundRobinAvailableKinds = [
  { type: 'divider', value: 'most_popular' },
  ...createLocationObjects(ROUND_ROBIN_MOST_POPULAR_KINDS),
  { type: 'divider', value: 'other' },
  ...createLocationObjects(OTHER_KINDS.filter((kind) => kind !== 'ask_invitee')),
]

export const createLocationValues = (selectedKind, locationData) => {
  const { kind, location, phoneNumber, additionalInfo, hideLocation } = locationData || {}
  const harmonizedKind = kind || selectedKind

  const values = {
    additional_info: null,
    hide_location: false,
    id: undefined,
    kind: harmonizedKind,
    location: null,
    phone_number: null,
    position: 0
  }

  switch (harmonizedKind) {
    case 'physical':
      values.location = location
      values.additional_info = additionalInfo
      break
    case 'inbound_call':
      values.additional_info = additionalInfo
      values.phone_number = phoneNumber
      break
    case 'custom':
      values.location = location
      values.hide_location = hideLocation === 'hidden'
      break
    default:
      break
  }

  return values
}
